import * as React from 'react';

import { cn } from '../../lib/utils';
import { Badge } from './badge';
import { normaliseQuoteRequestStatus } from '../../lib/quoteRequestStatus';

/**
 * A quote request's status, as a pill.
 *
 * Colours match the dashboard's pipeline tiles on purpose — the same amber
 * means "drafting" in both places — so a shop learns one set of signals rather
 * than two.
 *
 * Note what this does NOT use: the Badge `outline` variant. This app sets
 * `--border: transparent` and leans on background and elevation instead, which
 * leaves an outline badge rendering as bare text with no pill at all.
 */
const STATUS_STYLES = {
  new: 'bg-sky-100 text-sky-900 hover:bg-sky-100 dark:bg-sky-500/15 dark:text-sky-200',
  drafting: 'bg-amber-100 text-amber-900 hover:bg-amber-100 dark:bg-amber-500/15 dark:text-amber-200',
  'awaiting response': 'bg-muted text-muted-foreground hover:bg-muted',
  accepted:
    'bg-emerald-100 text-emerald-900 hover:bg-emerald-100 dark:bg-emerald-500/15 dark:text-emerald-200'
};

const STATUS_LABELS = {
  new: 'New',
  drafting: 'Drafting',
  'awaiting response': 'Awaiting response',
  accepted: 'Accepted'
};

function QuoteStatusBadge({ status, className }) {
  const value = normaliseQuoteRequestStatus(status);

  return (
    <Badge variant="secondary" className={cn('shrink-0', STATUS_STYLES[value], className)}>
      {STATUS_LABELS[value]}
    </Badge>
  );
}

export { QuoteStatusBadge };
